import React from 'react'
import { Flex,  Space, } from 'antd';
import { useNavigate } from 'react-router-dom';
import Bread from './Bread';
import MainSwitch from './MainSwitch';
import MainLogout from './MainLogout';
function Top(props) {
    const navi = useNavigate()
    return (        
        <Flex
            align='center'
            justify='space-between'
        >
            <Space 
                style={{           
                    backgroundColor:'#fff',
                    marginLeft:"40px"              
                }}
                size={20}
            >
                <span
                    style={{
                        fontWeight:"bolder",
                        fontSize:"30px",
                        color:'#1296DB',
                        width:'240px',
                        lineHeight:"60px",
                        textAlignLast:'justify',
                    }}
                >旅当家2022</span>
                {localStorage.getItem('ed_name') &&<Bread
                            t1={props.t1}
                            t2={props.t2}
                            t3={props.t3}
                            t4={props.t4}
                            t5={props.t5}
                            t6={props.t6}
                            t7={props.t7}
                            t8={props.t8}
                            t9={props.t9}
                            n1={props.n1}
                            n2={props.n2}
                            n3={props.n3}
                            n4={props.n4}
                            n5={props.n5}
                            n6={props.n6}
                            n7={props.n7}
                            n8={props.n8}
                            n9={props.n9}
                        />}
            </Space>
            
            <Space
                style={{                             
                    marginRight:"50px",                
                }}
                align='center'
            >
                
                {JSON.parse(localStorage.getItem('eu_id')) ? <div>
                        {/* <span>{localStorage.getItem('e_name').replace(/"/g,'')}</span> */}
                        {/* {(localStorage.getItem('e_name')!==localStorage.getItem('ed_name')) && <span><ApartmentOutlined /> {localStorage.getItem('ed_name').replace(/"/g,'')}</span>} */}
                        <MainSwitch />                  
                        <span>{JSON.parse(localStorage.getItem('ed_name'))} / </span>                    
                        <MainLogout />
                    </div>  : <>
                        <a 
                            onClick={() => {
                                navi('/Login')
                            }}
                        >登录</a>
                        <a 
                            style={{marginLeft:"10px"}}
                            onClick={() => {
                                navi('/Regist')
                            }}
                        >免费试用</a>
                    </>}
            </Space>
        </Flex>    
    )
}

export default Top